import React, { Fragment } from "react"
import { useTranslation } from "gatsby-plugin-react-i18next"
import Img from "gatsby-image"
import dayjs from "dayjs"
import customParseFormat from "dayjs/plugin/customParseFormat"
import Button from "../atoms/common/Button"
import contentTemplateClasses from "../../templates/ContentTemplate.module.scss"
dayjs.extend(customParseFormat)

type Props = {
  nodes: GatsbyTypes.ScheduleQuery.allScheduleJaCsv.nodes
  images: GatsbyTypes.ScheduleQuery.images
}
const Schedule: React.FC<Props> = ({ nodes, images }) => {
  const { t, i18n } = useTranslation("program")
  const timeFormat = i18n.language === "ja" ? "H:mm" : "h:mm A"

  return (
    <div>
      {nodes.map(
        ({ id, name, start, end, place, description, link, photo, genre }) => {
          const image =
            photo == null || photo == ""
              ? undefined
              : images.edges.find(({ node: { name } }) => name === photo)?.node
          return (
            <section key={id}>
              <h2>{name}</h2>
              {image && (
                <Img
                  fluid={(image as any).childImageSharp.fluid}
                  style={{ height: "300px" }}
                  imgStyle={{ objectFit: "contain" }}
                />
              )}
              <ul>
                <li>{`${dayjs(start, "hh:mm:ss").format(timeFormat)} - ${dayjs(
                  end,
                  "hh:mm:ss"
                ).format(timeFormat)}`}</li>
                <li>{place}</li>
                <li>
                  {genre
                    .split(",")
                    .map((v: string) => v.trim())
                    .filter(Boolean)
                    .join(", ")}
                </li>
              </ul>
              {description
                .split(/<br>/)
                .map((paragraph: string, i: number, array: string[]) => (
                  <Fragment key={i}>
                    {paragraph}
                    {array.length !== i + 1 && <br />}
                  </Fragment>
                ))}
              {link != null && link !== "" && (
                <div className={contentTemplateClasses.Button}>
                  <Button to={link} name={t("link")} />
                </div>
              )}
            </section>
          )
        }
      )}
    </div>
  )
}

export default Schedule
